import React from "react";
import * as styles from "./BVTerms.css";
import PropTypes from "prop-types";
import CancelIcon from "./icons/CancelIcon";
import { companyName, requiredAge } from "../config";

export class BVTerms extends React.Component {
    render() {
        const { onRequestClose } = this.props;
        return (
            <div className={styles.container}>
                <div
                    onClick={() => onRequestClose()}
                    className={styles.closeIcon}
                >
                    <CancelIcon />
                </div>
                <div className={styles.title}>Условия и положения</div>
                <p>
                    <strong>
                        УСЛОВИЯ ИСПОЛЬЗОВАНИЯ ОЦЕНОК И ОТЗЫВОВ И ВОПРОСОВ И
                        ОТВЕТОВ КЛИЕНТОВ
                    </strong>
                </p>
                <div>
                    Данные Условия использования регулируют ваше поведение в
                    связи с Оценками и обзорами Клиента и/или услугой Вопросы и
                    ответы, предоставляемой компанией{" "}
                    <strong> {companyName} </strong>, ("Услуга ООК").
                </div>
                <br />
                <div>
                    Отправляя любые материалы компании{" "}
                    <strong> {companyName} </strong>, Вы
                    гарантируете, что:
                </div>
                <ul className={styles.ul}>
                    <li>
                        Вы являетесь единственным автором и владельцем прав
                        интеллектуальной собственности на данный материал;
                    </li>
                    <li>
                        Вы добровольно отказываетесь от всех "моральных прав",
                        которые Вы можете иметь на данный материал;
                    </li>
                    <li>Все публикуемые Вами материалы являются точными;</li>
                    <li>
                        Вам не менее <strong> {requiredAge} </strong> лет;
                    </li>
                    <li>
                        Использование предоставленных Вами материалов не
                        нарушает настоящие Условия использования и не причиняет
                        вреда какому-либо физическому или юридическому лицу.
                    </li>
                </ul>
                <div>
                    Вы также заявляете, что не будете передавать материалы:
                </div>
                <ul className={styles.ul}>
                    <li>
                        Которые, как Вам известно, являются ложными, неточными
                        или вводящими в заблуждение;
                    </li>
                    <li>
                        Которые нарушают авторское право, патент, торговый знак,
                        коммерческую тайну или другие права собственности, права
                        на гласность или на конфиденциальность любого третьего
                        лица;
                    </li>
                    <li>
                        Которые нарушают законы, законодательные акты,
                        предписания или постановления (включая, без ограничений,
                        законы о защите прав потребителей, о недобросовестной
                        конкуренции, о борьбе с дискриминацией или о лживой
                        рекламе);
                    </li>
                    <li>
                        Которые являются или могут обоснованно считаться
                        дискредитирующими, клеветническими, полными ненависти,
                        расово или религиозно предвзятыми, оскорбительными,
                        незаконно угрожающими или преследующими любое лицо,
                        товарищество или корпорацию;
                    </li>
                    <li>
                        За которые Вы получили грант или вознаграждение от
                        любого несанкционированного третьего лица;
                    </li>
                    <li>
                        Которые содержат любую информацию, ссылающуюся на другие
                        веб-сайты, адреса, адреса электронной почты, контактную
                        информацию и номера телефонов;
                    </li>
                    <li>
                        Которые содержат любые компьютерные вирусы, "черви" или
                        другие потенциально вредоносные компьютерные программы
                        или файлы.
                    </li>
                </ul>
                <div>
                    Вы соглашаетесь освободить и обезопасить компанию{" "}
                    <strong> {companyName} </strong> (а также ее
                    должностных лиц, директоров, агентов, дочерние компании,
                    совместные предприятия, сотрудников и сторонних поставщиков
                    услуг, включая, без ограничений, Bazaarvoice, Inc.), от всех
                    претензий, требований и ущерба (прямого или косвенного)
                    любого рода и характера, известных и неизвестных, включая
                    разумные судебные издержки, вытекающие из нарушения Ваших
                    представлений и гарантий, указанных выше, нарушения
                    какого-либо закона или прав третьего лица.
                </div>
                <br />
                <div>
                    Вы безвозмездно предоставляете компании{" "}
                    <strong> {companyName} </strong> постоянное,
                    безотзывное, безвозмездное, непередаваемое право и лицензию
                    на использование, копирование, изменение, удаление в полном
                    объеме, адаптацию, публикацию, перевод, создание производных
                    работ и/или продажу и/или распространение любых отправленных
                    Вами материалов, и/или включение таких материалов в любую
                    форму, материал или технологию по всему миру.
                </div>
                <br />
                <div>
                    Все, передаваемое вами содержимое, может использоваться на
                    усмотрение компании{" "}
                    <strong> {companyName} </strong>. Компания{" "}
                    <strong> {companyName} </strong> оставляет за
                    собой право изменять, сжимать или не публиковать, удалять
                    любое содержимое на веб-сайте компании{" "}
                    <strong> {companyName} </strong>, которое, по
                    мнению компании <strong> {companyName} </strong>,
                    нарушает правила в отношении содержимого или любое другое
                    положение данных Условий использования. Компания{" "}
                    <strong> {companyName} </strong> не гарантирует,
                    что вам будет доступен какой-либо ресурс через компанию{" "}
                    <strong> {companyName} </strong> с целью
                    редактирования или удаления переданного вами содержания.
                    Оценки и письменные комментарии, как правило, публикуются в
                    течение двух-четырех рабочих дней. Однако, компания{" "}
                    <strong> {companyName} </strong> оставляет за
                    собой право удалить или отказаться публиковать любое
                    переданное содержимое, если это требуется по закону. Вы
                    подтверждаете, что вы, а не компания{" "}
                    <strong> {companyName} </strong>, несете
                    ответственность за содержание вашего содержимого. Никакое
                    переданное вами содержимое не налагает на компанию{" "}
                    <strong> {companyName} </strong>, ее агентов,
                    филиалы, аффилированные компании, партнеров или поставщиков
                    сторонних услуг или их директоров, должностных лиц и
                    сотрудников обязательство хранить конфиденциальность в его
                    отношении.
                </div>{" "}
            </div>
        );
    }
}

BVTerms.propTypes = {
    onRequestClose: PropTypes.func.isRequired
};